export default __webpack_public_path__ + "static/media/appendix1.5734cf8f.jpg";